<h1 mat-dialog-title>Updating {{proccessingSkillName}}</h1>
<mat-progress-bar mode="determinate" value="{{completeProgress}}"></mat-progress-bar>
    <ng-container *ngIf="processState === 'Processing'">
        <mat-dialog-content>Processing ({{currentProcessIndex + 1}} of {{totalProcessCount}}) - {{statusMessage}}</mat-dialog-content>
    </ng-container>
    <ng-container *ngIf="processState === 'Error-RunningSkill'">
        <div><h3>{{proccessingSkillName}} is started. Start/Stop Automatically?</h3></div>
        <mat-dialog-actions>
            <button mat-raised-button (click)="cancelProcess()">Cancel</button>&nbsp;&nbsp;
            <button mat-raised-button color="accent"  (click)="skipSkill()">Skip</button>&nbsp;&nbsp;
            <button mat-raised-button color="accent"  (click)="stopStartSkill()">Start/Stop</button>&nbsp;&nbsp;
            <button mat-raised-button color="primary" (click)="stopStartAll()">Start/Stop All</button> &nbsp;&nbsp;
        </mat-dialog-actions>
    </ng-container>
    <ng-container *ngIf="processState === 'Error-Skip'">
        <div><h3>{{statusMessage}}</h3></div>
        <mat-dialog-actions>
            <button mat-raised-button (click)="cancelProcess()">Cancel</button>&nbsp;&nbsp;
            <button mat-raised-button color="accent"  (click)="skipSkill()">Skip</button>&nbsp;&nbsp;
        </mat-dialog-actions>
    </ng-container>
    <ng-container *ngIf="processState === 'Results'">
        <h1 mat-dialog-title>Processing Complete</h1>
        <mat-dialog-content>Processed {{totalProcessCount}} skills</mat-dialog-content>
        <mat-dialog-actions>
            <button mat-raised-button color="primary" (click)="closeFinish()">Return To Skills</button> &nbsp;&nbsp;
        </mat-dialog-actions>
    </ng-container>



